import { z } from "zod";
/**
 * What players say to each other at the table (review 0022): a fixed list, so nothing a player types
 * reaches anyone. Six quick messages and eight emoji; each viewer reads them in their own language.
 */
export const REACTIONS = [
    "gg",
    "congrats",
    "hurry",
    "sorry",
    "wow",
    "thanks",
    "smile",
    "laugh",
    "surprised",
    "sad",
    "angry",
    "thumbs",
    "clap",
    "fire",
];
export const reactionSchema = z.enum(REACTIONS);
/**
 * Gifts that sit on a player's picture until they tap them away or get another (review 0022, the
 * owner's Zynga-style brief): teasing, friendly, flirty.
 */
export const GIFTS = [
    "turtle",
    "bottle",
    "clover",
    "tea",
    "coffee",
    "crown",
    "rose",
    "heart",
    "chocolate",
];
export const giftSchema = z.enum(GIFTS);
/** A gift on a seated player: what, from whom, and when it arrived (a new one slides in). */
export const heldGiftSchema = z.object({
    gift: giftSchema,
    from: z.string().min(1),
    at: z.number().int().nonnegative(),
});
//# sourceMappingURL=social.js.map